import TooManyRequestsError from '../errors/TooManyRequestsError';
import getRateLimit, { hasRateLimitHeader } from './getRateLimit';
/**
 * Handle too many requests error
 *
 * @param  {Error} error - caught exception
 * @return {Response|Error} - thrown error or returned response if there is rate limit timer
 */

export default function handleTooManyRequests(error) {
  if (error instanceof TooManyRequestsError && hasRateLimitHeader(error.response)) {
    error.body = getRateLimit(error.response); // eslint-disable-line no-param-reassign
  }

  throw error;
}